import $ from 'jquery'
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { Modal } from 'bootstrap';
import { Cookies } from './cookies';
import './page-transition';
import 'swiper/css';
import 'swiper/css/navigation';

const HOME_CTA_POPUP_KEY = 'homeCtaPopupClosedAt';
const HOME_CTA_POPUP_DEFAULT_HOURS = 24;

const getHomeCtaPopupCooldownMs = () => {
    const hours = Number(window.popupConfig?.cooldownHours ?? HOME_CTA_POPUP_DEFAULT_HOURS);
    const sanitized = Number.isFinite(hours) && hours > 0 ? hours : HOME_CTA_POPUP_DEFAULT_HOURS;
    return sanitized * 60 * 60 * 1000;
};

const getStoredHomeCtaTimestamp = () => {
    try {
        return localStorage.getItem(HOME_CTA_POPUP_KEY);
    } catch (error) {
        return null;
    }
};

const recordHomeCtaPopupClose = () => {
    try {
        localStorage.setItem(HOME_CTA_POPUP_KEY, Date.now().toString());
    } catch (error) {
        // ignore storage errors
    }
};

const hasHomeCtaPopupCooldownExpired = () => {
    const stored = getStoredHomeCtaTimestamp();
    if (!stored) {
        return true;
    }

    const lastTimestamp = Number.parseInt(stored, 10);
    if (Number.isNaN(lastTimestamp)) {
        return true;
    }

    return Date.now() - lastTimestamp >= getHomeCtaPopupCooldownMs();
};

window.MauticDomain = "https://mautic.metodomaravilla.com";
window.MauticLang   = {
    'submittingMessage': "Por favor espere..."
}

var modal = {
    openClaseGratis: function(triggerElement) {
        const claseGratisModal = document.getElementById('modaClaseGratis');
        if (claseGratisModal) {
            const origin = triggerElement?.dataset?.openClaseGratis || 'adult';
            const cta = triggerElement?.dataset?.claseGratisCta || '';
            const links = claseGratisModal.querySelectorAll('[data-clase-gratis-link]');

            claseGratisModal.dataset.origin = origin;

            links.forEach((link) => {
                const baseUrl = origin === 'infantil' ? link.dataset.infantilUrl : link.dataset.adultUrl;

                if (!baseUrl) {
                    return;
                }

                const url = new URL(baseUrl, window.location.origin);
                url.searchParams.set('origin', origin);
                url.searchParams.set('origin_path', window.location.pathname);

                if (cta) {
                    url.searchParams.set('origin_cta', cta);
                }

                link.href = url.toString();
            });

            setTimeout(() => {
                const claseGratis = new Modal(claseGratisModal);
                claseGratis.show();
            }, 100);
        }
    },
    openClaseSuelta: function(utm_content) {
        const claseSueltaModal = document.getElementById('modaClaseSuelta');
        if (claseSueltaModal) {
            setTimeout(() => {
                const claseSuelta = new Modal(claseSueltaModal);
                claseSuelta.show();
            }, 100);
        }
    },
    openDondeEntrenar: function(triggerElement) {
        const reservaModal = document.getElementById('modalDondeEntrenar');
        if (reservaModal) {
            const modalReserva = Modal.getOrCreateInstance(reservaModal);
            reservaModal.addEventListener('shown.bs.modal', () => {
                reservaModal.querySelector('.mauticform-input')?.focus();
            }, { once: true });
            reservaModal.addEventListener('hidden.bs.modal', () => {
                triggerElement?.focus();
            }, { once: true });
            modalReserva.show();
        }
    },
    openSuscribirseNewsletter: function(triggerElement) {
        const reservaModal = document.getElementById('modalInscribirseNewsletter');
        if (reservaModal) {
            const modalReserva = Modal.getOrCreateInstance(reservaModal);
            reservaModal.addEventListener('shown.bs.modal', () => {
                reservaModal.querySelector('.mauticform-input')?.focus();
            }, { once: true });
            reservaModal.addEventListener('hidden.bs.modal', () => {
                triggerElement?.focus();
            }, { once: true });
            modalReserva.show();
        }
    },
};

$(function() {
    Cookies.init();

    const scheduleDataElement = document.getElementById('scheduleData');
    const scheduleDialog = document.getElementById('scheduleDialog');

    if (scheduleDataElement && scheduleDialog) {
        const scheduleTitle = scheduleDialog.querySelector('[data-schedule-title]');
        const scheduleGrid = scheduleDialog.querySelector('[data-schedule-grid]');
        const scheduleScroll = scheduleDialog.querySelector('[data-schedule-scroll]');
        const scheduleClose = scheduleDialog.querySelector('[data-schedule-close]');
        const scheduleMobileGrid = scheduleDialog.querySelector('[data-schedule-mobile-grid]');
        const scheduleMobileScroll = scheduleDialog.querySelector('[data-schedule-mobile-scroll]');
        const scheduleCenterSwitches = scheduleDialog.querySelectorAll('[data-schedule-dialog-center]');
        const allowedTones = new Set(['level12', 'level34', 'kids']);
        let scheduleData = null;
        let activeCenterKey = null;

        try {
            scheduleData = JSON.parse(scheduleDataElement.textContent);
        } catch (error) {
            console.error('No se ha podido cargar el horario.', error);
        }

        const createScheduleCell = (session, dayLabel) => {
            const cell = document.createElement('div');
            cell.className = 'schedule-table__cell';
            cell.setAttribute('role', 'cell');

            if (!session) {
                cell.classList.add('schedule-table__cell--empty');
                cell.setAttribute('aria-label', `${dayLabel}: sin clase en esta franja`);
                return cell;
            }

            const tone = allowedTones.has(session.tone) ? session.tone : 'neutral';
            const label = document.createElement('strong');
            const time = document.createElement('span');

            cell.classList.add(`schedule-table__cell--${tone}`);
            cell.setAttribute('aria-label', `${dayLabel}: ${session.label}, ${session.time}`);
            label.textContent = session.label;
            time.textContent = session.time;
            cell.append(label, time);

            return cell;
        };

        const resolveScheduleSession = (row, day, dayIndex) => {
            if (Object.prototype.hasOwnProperty.call(row, day.id)) {
                return row[day.id];
            }

            if (dayIndex < 5 && row.weekdays) {
                return row.weekdays;
            }

            return row.all || null;
        };

        const getSessionStart = (session) => session.time.split('–')[0].trim();

        const getTimeInMinutes = (time) => {
            const [hours, minutes] = time.split(':').map(Number);
            return (hours * 60) + minutes;
        };

        const getMobileTimeSlots = (center) => {
            const slots = new Map();

            center.rows.forEach((row) => {
                scheduleData.days.forEach((day, dayIndex) => {
                    const session = resolveScheduleSession(row, day, dayIndex);

                    if (session) {
                        const start = getSessionStart(session);
                        slots.set(start, getTimeInMinutes(start));
                    }
                });
            });

            return Array.from(slots, ([time, minutes]) => ({ time, minutes }))
                .sort((first, second) => first.minutes - second.minutes);
        };

        const getSessionsAtTime = (center, day, dayIndex, time) => center.rows
            .map((row) => resolveScheduleSession(row, day, dayIndex))
            .filter((session) => session && getSessionStart(session) === time);

        const createMobileSlotContent = (session) => {
            const item = document.createElement('div');
            const marker = document.createElement('i');
            const copy = document.createElement('div');
            const label = document.createElement('strong');
            const time = document.createElement('span');
            const tone = allowedTones.has(session.tone) ? session.tone : 'neutral';

            item.className = `schedule-mobile-grid__class schedule-mobile-grid__class--${tone}`;
            item.setAttribute('aria-label', `${session.label}, ${session.time}`);
            marker.setAttribute('aria-hidden', 'true');
            copy.className = 'schedule-mobile-grid__class-copy';
            label.textContent = session.label;
            time.textContent = session.time;
            copy.append(label, time);
            item.append(marker, copy);

            return item;
        };

        const renderMobileSchedule = (center) => {
            const days = scheduleData.days;
            const timeSlots = getMobileTimeSlots(center);
            let previousPeriod = null;

            scheduleMobileGrid.replaceChildren();
            scheduleMobileGrid.style.setProperty('--schedule-mobile-days', days.length);

            const headerRow = document.createElement('div');
            const corner = document.createElement('div');
            headerRow.className = 'schedule-mobile-grid__row schedule-mobile-grid__row--header';
            headerRow.setAttribute('role', 'row');
            corner.className = 'schedule-mobile-grid__corner';
            corner.setAttribute('role', 'columnheader');
            corner.textContent = 'Hora';
            headerRow.appendChild(corner);

            days.forEach((day) => {
                const header = document.createElement('div');
                header.className = 'schedule-mobile-grid__day';
                header.setAttribute('role', 'columnheader');
                header.textContent = day.short || day.label;
                headerRow.appendChild(header);
            });

            scheduleMobileGrid.appendChild(headerRow);

            timeSlots.forEach((slot) => {
                const period = slot.minutes < 14 * 60 ? 'Mañana' : 'Tarde';
                const isPeriodStart = period !== previousPeriod;
                const row = document.createElement('div');
                const timeCell = document.createElement('div');

                previousPeriod = period;
                row.className = 'schedule-mobile-grid__row';
                row.setAttribute('role', 'row');

                if (isPeriodStart) {
                    row.classList.add('schedule-mobile-grid__row--period-start');
                }

                timeCell.className = 'schedule-mobile-grid__time';
                timeCell.setAttribute('role', 'rowheader');

                if (isPeriodStart) {
                    const periodLabel = document.createElement('span');
                    periodLabel.textContent = period;
                    timeCell.appendChild(periodLabel);
                }

                const timeLabel = document.createElement('strong');
                timeLabel.textContent = slot.time;
                timeCell.appendChild(timeLabel);
                row.appendChild(timeCell);

                days.forEach((day, dayIndex) => {
                    const cell = document.createElement('div');
                    const sessions = getSessionsAtTime(center, day, dayIndex, slot.time);
                    cell.className = 'schedule-mobile-grid__cell';
                    cell.setAttribute('role', 'cell');

                    if (isPeriodStart) {
                        cell.classList.add('schedule-mobile-grid__cell--period-start');
                    }

                    if (!sessions.length) {
                        const empty = document.createElement('span');
                        cell.classList.add('schedule-mobile-grid__cell--empty');
                        cell.setAttribute('aria-label', `${day.label}, ${slot.time}: sin clase`);
                        empty.setAttribute('aria-hidden', 'true');
                        empty.textContent = '—';
                        cell.appendChild(empty);
                    } else {
                        sessions.forEach((session) => cell.appendChild(createMobileSlotContent(session)));
                    }

                    row.appendChild(cell);
                });

                scheduleMobileGrid.appendChild(row);
            });

            scheduleMobileScroll.scrollTo({ left: 0, top: 0 });
        };

        const renderSchedule = (centerKey) => {
            const center = scheduleData?.centers?.[centerKey];
            const days = scheduleData?.days || [];

            if (!center || !days.length) {
                return false;
            }

            activeCenterKey = centerKey;
            scheduleTitle.textContent = center.title;
            scheduleGrid.replaceChildren();
            scheduleGrid.style.setProperty('--schedule-columns', days.length);

            scheduleCenterSwitches.forEach((switchButton) => {
                const isActive = switchButton.dataset.scheduleDialogCenter === centerKey;
                switchButton.classList.toggle('is-active', isActive);
                switchButton.setAttribute('aria-pressed', String(isActive));
            });

            const headerRow = document.createElement('div');
            headerRow.className = 'schedule-table__row schedule-table__row--header';
            headerRow.setAttribute('role', 'row');

            days.forEach((day) => {
                const header = document.createElement('div');
                header.className = 'schedule-table__header';
                header.setAttribute('role', 'columnheader');
                header.textContent = day.label;
                headerRow.appendChild(header);
            });

            scheduleGrid.appendChild(headerRow);

            center.rows.forEach((row) => {
                const scheduleRow = document.createElement('div');
                scheduleRow.className = 'schedule-table__row';
                scheduleRow.setAttribute('role', 'row');

                days.forEach((day, dayIndex) => {
                    scheduleRow.appendChild(createScheduleCell(resolveScheduleSession(row, day, dayIndex), day.label));
                });

                scheduleGrid.appendChild(scheduleRow);
            });

            renderMobileSchedule(center);
            scheduleScroll.scrollTo({ left: 0, top: 0 });
            return true;
        };

        const closeSchedule = () => {
            if (typeof scheduleDialog.close === 'function') {
                scheduleDialog.close();
            } else {
                scheduleDialog.removeAttribute('open');
            }
        };

        document.querySelectorAll('[data-schedule-center]').forEach((trigger) => {
            trigger.addEventListener('click', () => {
                if (!renderSchedule(trigger.dataset.scheduleCenter)) {
                    return;
                }

                if (typeof scheduleDialog.showModal === 'function') {
                    scheduleDialog.showModal();
                } else {
                    scheduleDialog.setAttribute('open', '');
                }

                window.requestAnimationFrame(() => {
                    scheduleScroll.scrollTo({ left: 0, top: 0 });
                    scheduleMobileScroll.scrollTo({ left: 0, top: 0 });
                });
            });
        });

        scheduleCenterSwitches.forEach((switchButton) => {
            switchButton.addEventListener('click', () => {
                const centerKey = switchButton.dataset.scheduleDialogCenter;

                if (centerKey !== activeCenterKey) {
                    renderSchedule(centerKey);
                }
            });
        });

        scheduleMobileScroll.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) {
                return;
            }

            event.preventDefault();
            scheduleMobileScroll.scrollBy({
                left: event.key === 'ArrowRight' ? 152 : -152,
                behavior: 'smooth',
            });
        });

        scheduleClose.addEventListener('click', closeSchedule);
        scheduleDialog.addEventListener('click', (event) => {
            if (event.target === scheduleDialog) {
                closeSchedule();
            }
        });
    }

    $('section.beneficios .beneficios').each(function() {
        const list = $(this);

        list.addClass('beneficios--enhanced');
        list.children('.beneficio').each(function() {
            const item = $(this);
            const trigger = item.children('.acc');
            const panel = $('#' + trigger.attr('aria-controls'));
            const isOpen = trigger.attr('aria-expanded') === 'true';

            item.toggleClass('open', isOpen);
            panel.attr('aria-hidden', String(!isOpen));
        });
    });

    $('section.beneficios .acc').on('click', function() {
        const trigger = $(this);
        const item = trigger.closest('.beneficio');
        const list = item.parent('.beneficios');
        const panel = $('#' + trigger.attr('aria-controls'));
        const isOpen = trigger.attr('aria-expanded') === 'true';

        list.children('.beneficio').not(item).each(function() {
            const sibling = $(this);
            const siblingTrigger = sibling.children('.acc');
            const siblingPanel = $('#' + siblingTrigger.attr('aria-controls'));

            sibling.removeClass('open');
            siblingTrigger.attr('aria-expanded', 'false');
            siblingPanel.attr('aria-hidden', 'true');
        });

        item.toggleClass('open', !isOpen);
        trigger.attr('aria-expanded', String(!isOpen));
        panel.attr('aria-hidden', String(isOpen));
    });

    $('section.faq .aq').on('click', function() {
        const trigger = $(this);
        const item = trigger.closest('.faq-item');
        const answer = $('#' + trigger.attr('aria-controls'));
        const isOpen = trigger.attr('aria-expanded') === 'true';

        item.toggleClass('is-open', !isOpen);
        trigger.attr('aria-expanded', String(!isOpen));
        answer.attr('aria-hidden', String(isOpen));
    });

    const nivelesSwiper = new Swiper('.swiper-niveles', {
        modules: [Navigation],
        lazyPreloadPrevNext: 1,
        loop: true,
        grabCursor: true,
        slidesPerView: 'auto',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 0,
        centeredSlides: true
    });

    let isNivelDragging = false;

    const clearNivelDragFocus = () => {
        document.querySelectorAll('.swiper-niveles .is-drag-focus').forEach((slide) => {
            slide.classList.remove('is-drag-focus');
        });
    };

    const preserveNivelDragFocus = () => {
        isNivelDragging = true;
        clearNivelDragFocus();
        document.querySelector('.swiper-niveles')?.classList.add('is-dragging');
        document.querySelector('.swiper-niveles .swiper-slide-active')?.classList.add('is-drag-focus');
    };

    const releaseNivelDragFocus = () => {
        isNivelDragging = false;
        document.querySelector('.swiper-niveles')?.classList.remove('is-dragging');
        window.setTimeout(clearNivelDragFocus, 350);
    };

    nivelesSwiper.on('touchStart', preserveNivelDragFocus);
    nivelesSwiper.on('sliderFirstMove', preserveNivelDragFocus);
    nivelesSwiper.on('touchEnd', releaseNivelDragFocus);
    nivelesSwiper.on('transitionEnd', () => {
        if (!isNivelDragging) {
            clearNivelDragFocus();
        }
    });

    document.querySelectorAll('[data-drag-scroll]').forEach((scroller) => {
        let activePointerId = null;
        let pointerStartX = 0;
        let scrollStartX = 0;

        const stopDragging = (event) => {
            if (activePointerId === null || (event.pointerId !== undefined && event.pointerId !== activePointerId)) {
                return;
            }

            const pointerId = activePointerId;
            activePointerId = null;
            scroller.classList.remove('is-dragging');

            if (scroller.hasPointerCapture?.(pointerId)) {
                scroller.releasePointerCapture(pointerId);
            }
        };

        scroller.addEventListener('pointerdown', (event) => {
            const isInteractive = event.target.closest('a, button, input, select, textarea, label');
            const canScroll = scroller.scrollWidth > scroller.clientWidth;

            if (event.pointerType !== 'mouse' || event.button !== 0 || isInteractive || !canScroll) {
                return;
            }

            activePointerId = event.pointerId;
            pointerStartX = event.clientX;
            scrollStartX = scroller.scrollLeft;
            scroller.classList.add('is-dragging');
            scroller.setPointerCapture(event.pointerId);
            event.preventDefault();
        });

        scroller.addEventListener('pointermove', (event) => {
            if (event.pointerId !== activePointerId) {
                return;
            }

            scroller.scrollLeft = scrollStartX - (event.clientX - pointerStartX);
            event.preventDefault();
        });

        scroller.addEventListener('pointerup', stopDragging);
        scroller.addEventListener('pointercancel', stopDragging);
        scroller.addEventListener('lostpointercapture', stopDragging);
    });

    if (document.querySelector('.evento-sergio-valencia-experience__swiper')) {
        new Swiper('.evento-sergio-valencia-experience__swiper', {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: '.evento-sergio-valencia-experience__arrow--next',
                prevEl: '.evento-sergio-valencia-experience__arrow--prev',
            },
        });
    }

    $('.centros-tarifas-horarios .wp-buttons [data-centro]').on('click', function(e) {
        e.preventDefault();
        const targetCentro = $(this).data('centro');
        const wrapper = $('.centros-tarifas-horarios');
        wrapper.find('.centros-container').addClass('is-hidden');
        wrapper.find('.ciudades-output').addClass('is-visible');
        wrapper.find('.wp-buttons .btn, .ciudades-switcher .btn').removeClass('active');
        wrapper.find(`[data-centro="${targetCentro}"]`).addClass('active');
        wrapper.find('.ciudad-panel').removeClass('is-active');
        wrapper.find(`.ciudad-panel[data-centro-panel="${targetCentro}"]`).addClass('is-active');
    });

    $('.centros-tarifas-horarios .ciudades-switcher [data-centro]').on('click', function(e) {
        e.preventDefault();
        const targetCentro = $(this).data('centro');
        const wrapper = $('.centros-tarifas-horarios');
        wrapper.find('.wp-buttons .btn, .ciudades-switcher .btn').removeClass('active');
        wrapper.find(`[data-centro="${targetCentro}"]`).addClass('active');
        wrapper.find('.ciudad-panel').removeClass('is-active');
        wrapper.find(`.ciudad-panel[data-centro-panel="${targetCentro}"]`).addClass('is-active');
    });

    $('.planes-infantil .wp-buttons [data-centro]').on('click', function(e) {
        e.preventDefault();
        const targetCentro = $(this).data('centro');
        const wrapper = $(this).closest('.planes-infantil');
        wrapper.find('.wp-buttons .btn').removeClass('active').attr('aria-selected', 'false');
        $(this).addClass('active').attr('aria-selected', 'true');
        const currentPanel = wrapper.find('.ciudad-panel.is-active');
        const nextPanel = wrapper.find(`.ciudad-panel[data-centro-panel="${targetCentro}"]`);
        if (currentPanel.is(nextPanel)) return;
        currentPanel.removeClass('is-active').attr('aria-hidden', 'true');
        setTimeout(() => nextPanel.addClass('is-active').attr('aria-hidden', 'false'), 260);
    });

    $('.classes-toggle-btn').on('click', function(e) {
        e.preventDefault();
        const btn = $(this);
        const content = btn.siblings('.classes-toggle-content');
        btn.toggleClass('is-active');
        content.toggleClass('is-active');
    });

    $('[data-open-clase-gratis]').on('click', function(e) {
        e.preventDefault();
        modal.openClaseGratis(this);
    });

    $('#btn-clase-suelta').on('click', function(e) {
        e.preventDefault();
        modal.openClaseSuelta();
    });

    $('#btn-donde-entrenar').on('click', function(e) {
        e.preventDefault();
        modal.openDondeEntrenar(this);
    });

    $('#btn-suscribirse-newsletter').on('click', function(e) {
        e.preventDefault();
        modal.openSuscribirseNewsletter(this);
    });

    // Forms Mautic
    if (typeof MauticSDKLoaded == 'undefined') {
        var MauticSDKLoaded = true;
        var head            = document.getElementsByTagName('head')[0];
        var script          = document.createElement('script');
        script.type         = 'text/javascript';
        script.src          = 'https://mautic.metodomaravilla.com/media/js/mautic-form.js?v4def8b8f';
        script.onload       = function() {
            MauticSDK.onLoad();
        };
        head.appendChild(script);
        var MauticDomain = 'https://mautic.metodomaravilla.com';
        var MauticLang   = {
            'submittingMessage': "Por favor espere..."
        }
    } else if (typeof MauticSDK != 'undefined') {
        MauticSDK.onLoad();
    }

    const initHomeCtaPopup = () => {
        if (!window.popupConfig?.homeCtaActive) {
            return;
        }

        const popupEl = document.getElementById('homeCtaPopup');
        if (!popupEl) {
            return;
        }

        const homePopupModal = new Modal(popupEl);
        popupEl.addEventListener('hidden.bs.modal', () => {
            recordHomeCtaPopupClose();
        });

        if (hasHomeCtaPopupCooldownExpired()) {
            setTimeout(() => homePopupModal.show(), 500);
        }
    };

    initHomeCtaPopup();

    const initHomeRoutineOfferModal = () => {
        const selectorEl = document.getElementById('homeRoutineOfferModal');
        const popupEl = document.getElementById('homeCtaPopup');
        if (!selectorEl) {
            return;
        }

        const selectorModal = Modal.getOrCreateInstance(selectorEl);
        const centreStep = selectorEl.querySelector('[data-routine-offer-step="centre"]');
        const levelStep = selectorEl.querySelector('[data-routine-offer-step="level"]');
        const centreName = selectorEl.querySelector('[data-routine-offer-centre-name]');
        const centreButtons = selectorEl.querySelectorAll('[data-routine-offer-centre]');
        const levelLinks = selectorEl.querySelectorAll('[data-routine-offer-level]');
        const backButton = selectorEl.querySelector('[data-routine-offer-back]');
        let selectedCentre = null;
        let trigger = null;

        const registrarEventoVueltaRutina = (evento, datos = {}) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: evento,
                oferta: 'tarifa_full_34_90',
                origen: 'popup_inicio',
                ...datos,
            });
        };

        const showCentreStep = () => {
            centreStep.hidden = false;
            levelStep.hidden = true;
            selectedCentre = null;
            centreButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
        };

        const showLevelStep = (centre) => {
            selectedCentre = centre;
            centreName.textContent = centre === 'lugo' ? 'Centro de Lugo' : 'Centro de Valencia';
            levelLinks.forEach((link) => {
                link.href = link.dataset[`routineOffer${centre.charAt(0).toUpperCase()}${centre.slice(1)}`];
            });
            centreStep.hidden = true;
            levelStep.hidden = false;
            levelLinks[0]?.focus();
        };

        document.querySelectorAll('[data-open-home-routine-offer]').forEach((button) => {
            button.addEventListener('click', () => {
                trigger = button;
                showCentreStep();
                registrarEventoVueltaRutina('popup_vuelta_rutina_abierto');

                if (popupEl?.classList.contains('show')) {
                    popupEl.addEventListener('hidden.bs.modal', () => selectorModal.show(), { once: true });
                    Modal.getOrCreateInstance(popupEl).hide();
                    return;
                }

                selectorModal.show();
            });
        });

        centreButtons.forEach((button) => {
            button.addEventListener('click', () => {
                centreButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
                button.setAttribute('aria-pressed', 'true');
                const ciudad = button.dataset.routineOfferCentre;
                registrarEventoVueltaRutina('ciudad_vuelta_rutina_seleccionada', { ciudad });
                showLevelStep(ciudad);
            });
        });

        levelLinks.forEach((link) => {
            link.addEventListener('click', () => {
                registrarEventoVueltaRutina('nivel_vuelta_rutina_seleccionado', {
                    ciudad: selectedCentre,
                    nivel: link.dataset.routineOfferLevel,
                    url_destino: link.href,
                });
            });
        });

        backButton?.addEventListener('click', showCentreStep);
        selectorEl.addEventListener('hidden.bs.modal', () => {
            showCentreStep();
            trigger?.focus();
        });
    };

    initHomeRoutineOfferModal();

    // Shared membership modal — CSS-slide 2-step flow
    const plansModalEl = document.getElementById('modalPlanes');
    if (plansModalEl) {
        const track          = plansModalEl.querySelector('#plans-modal-slides-track');
        const dot1           = plansModalEl.querySelector('#plans-modal-step-1');
        const dot2           = plansModalEl.querySelector('#plans-modal-step-2');
        const monthlyPriceEl = plansModalEl.querySelector('#plans-modal-monthly-price');
        const quarterlyPriceEl = plansModalEl.querySelector('#plans-modal-quarterly-price');
        const annualPriceEl  = plansModalEl.querySelector('#plans-modal-annual-price');
        const monthlyCopyEl  = plansModalEl.querySelector('#plans-modal-monthly-copy');
        const quarterlyCopyEl = plansModalEl.querySelector('#plans-modal-quarterly-copy');
        const annualCopyEl   = plansModalEl.querySelector('#plans-modal-annual-copy');
        const monthlyEnrollmentEl = plansModalEl.querySelector('#plans-modal-monthly-enrollment');
        const quarterlyEnrollmentEl = plansModalEl.querySelector('#plans-modal-quarterly-enrollment');
        const annualEnrollmentEl = plansModalEl.querySelector('#plans-modal-annual-enrollment');
        const monthlyLink    = plansModalEl.querySelector('#plans-modal-monthly-link');
        const quarterlyLink  = plansModalEl.querySelector('#plans-modal-quarterly-link');
        const annualLink     = plansModalEl.querySelector('#plans-modal-annual-link');
        const annualOption   = plansModalEl.querySelector('#plans-modal-annual-option');
        const planNameEl     = plansModalEl.querySelector('#plans-modal-plan-name');
        const backBtn        = plansModalEl.querySelector('#plans-modal-back');

        let urls = {};

        function goToSlide(index) {
            track.style.transform = `translateX(-${index * 100}%)`;
            dot1.classList.toggle('active', index === 0);
            dot1.classList.toggle('done',   index !== 0);
            dot2.classList.toggle('active', index === 1);
            dot2.classList.remove('done');
        }

        plansModalEl.addEventListener('show.bs.modal', (event) => {
            const t = event.relatedTarget;
            if (!t) return;

            urls = {
                monthly12:  t.dataset.monthlyLevel12Url  || '#',
                monthly34:  t.dataset.monthlyLevel34Url  || '#',
                quarterly12: t.dataset.quarterlyLevel12Url || '#',
                quarterly34: t.dataset.quarterlyLevel34Url || '#',
                annual12:   t.dataset.annualLevel12Url   || '#',
                annual34:   t.dataset.annualLevel34Url   || '#',
            };

            planNameEl.textContent      = t.dataset.planName    || '';
            monthlyPriceEl.textContent  = t.dataset.monthlyPrice  ? t.dataset.monthlyPrice  + '€'     : '';
            quarterlyPriceEl.textContent = t.dataset.quarterlyPrice ? t.dataset.quarterlyPrice + '€': '';
            annualPriceEl.textContent   = t.dataset.annualPrice ? t.dataset.annualPrice + '€' : '';
            monthlyCopyEl.textContent   = t.dataset.monthlyCopy || 'Renueva mes a mes con total flexibilidad.';
            quarterlyCopyEl.textContent = t.dataset.quarterlyCopy || 'Ahorra pagando 3 meses de una vez.';
            annualCopyEl.textContent    = t.dataset.annualCopy || 'Entrena durante todo el año.';
            monthlyEnrollmentEl.textContent = t.dataset.monthlyEnrollment || 'Matrícula de 25€ para nuevos usuarios.';
            quarterlyEnrollmentEl.textContent = t.dataset.quarterlyEnrollment || 'Matrícula de 25€ para nuevos usuarios.';
            annualEnrollmentEl.textContent = t.dataset.annualEnrollment || 'Sin matrícula.';
            annualOption.hidden         = !t.dataset.annualPrice;
            backBtn.hidden              = t.dataset.skipLevel === 'true';

            if (t.dataset.skipLevel === 'true') {
                monthlyLink.href = urls.monthly12;
                quarterlyLink.href = urls.quarterly12;
                annualLink.href = urls.annual12;
                goToSlide(1);
            } else {
                goToSlide(0);
            }
        });

        plansModalEl.addEventListener('hidden.bs.modal', () => goToSlide(0));

        plansModalEl.querySelectorAll('.btn-plans-modal-level').forEach((btn) => {
            btn.addEventListener('click', () => {
                const level = btn.dataset.level;
                monthlyLink.href  = level === '12' ? urls.monthly12  : urls.monthly34;
                quarterlyLink.href = level === '12' ? urls.quarterly12 : urls.quarterly34;
                annualLink.href   = level === '12' ? urls.annual12   : urls.annual34;
                goToSlide(1);
            });
        });

        backBtn.addEventListener('click', () => goToSlide(0));

        plansModalEl.querySelectorAll('a[href="#"]').forEach((link) => {
            link.addEventListener('click', (event) => {
                if (link.getAttribute('href') === '#') {
                    event.preventDefault();
                }
            });
        });
    }

});
